import * as React from "react"
import styled from "styled-components"
import H3 from "../atoms/typography/H3"

interface RadioButtonBarProps {
  items: Array<{ id: string; title: string }>
  selectedValue: string
  onClickItem: (item: any) => void
}

const Bar = styled.div`
  border-radius: ${(props) => props.theme.borders.buttonRadius};
  border: ${(props) => `1px solid ${props.theme.colors.greyDark}`};
  display: flex;
  justify-content: space-between;
  overflow: hidden;
`

const RadioItem = styled.div<{ selected: boolean }>`
  padding: ${(props) => `${props.theme.spacings.medium} ${props.theme.spacings.large}`};
  border-radius: ${(props) => props.theme.borders.buttonRadius};
  border-width: 1px;
  cursor: pointer;
  background: ${(props) => (props.selected ? props.theme.colors.greyDark : "transparent")};
`

const RadioButtonBar: React.FunctionComponent<RadioButtonBarProps> = ({ items, selectedValue, onClickItem }) => {
  return (
    <Bar>
      {items.map((item) => (
        <RadioItem key={item.id} selected={selectedValue === item.id} onClick={() => onClickItem(item.id)}>
          <H3 color={selectedValue === item.id ? "white" : undefined} textAlign="center">
            {item.title}
          </H3>
        </RadioItem>
      ))}
    </Bar>
  )
}

export default RadioButtonBar
